
import Vue from "vue";
import { NewBoxesApiFunc, NewSensorsApiFunc, setAccessToken } from "@/api";
import { Sensor, Box } from "@/models";

import TheTemplate from "../../TheNoSidebarTemplate.vue";
import BaseCloseButton from "@/components/BaseCloseButton.vue";
import ToiletBoxEditor from "./components/ToiletBoxEditor.vue";

export type DataType = {
  sensors: Array<Sensor>;
};

export default Vue.extend({
  name: "ToiletBoxCreateScreen",

  components: {
    TheTemplate,
    ToiletBoxEditor,
    BaseCloseButton,
  },

  data(): DataType {
    return {
      sensors: [],
    };
  },

  mounted(): void {
    this.fetchSensors();
  },

  methods: {
    async fetchSensors(): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewSensorsApiFunc().listSensors(
        companyId,
        undefined,
        undefined,
        false
      );

      if (err != null) {
        this.$handleApiError(err, this.fetchSensors);
        return;
      }

      this.sensors = data.list;
    },

    async createBox(box: Box): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      this.$setLoading(true);

      const toiletId = this.$route.params.toiletId;
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewBoxesApiFunc().createBox(
        companyId,
        toiletId,
        box
      );

      if (err != null) {
        this.$handleApiError(err, () => {
          this.createBox(box);
        });
        this.$setLoading(false);
        return;
      }
      if (data?.id === undefined) {
        this.$handleApiError(undefined, () => {
          this.createBox(box);
        });
        this.$setLoading(false);
        return;
      }
      this.$setLoading(false);
      this.$setChecked(true);
      this.$afterSuccessRequest(() => {
        this.$router.push({
          name: `company-toilet-boxes`,
          params: {
            updated: "true",
            toiletId: toiletId,
          },
        });
      }, 2);
    },

    afterLeave(): void {
      this.$setChecked(false);
    },
  },
});
